(function () {
  angular
    .module("akitabox.ui.dialogs.document.upload")
    .factory("UploadDocumentDialog", UploadDocumentDialog);

  /* @ngInject */
  function UploadDocumentDialog($log, $q, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl:
        "app/core/ui/dialogs/document/upload/upload-file.dialog.html",
      controller: "UploadDocumentDialogController",
      controllerAs: "dialog",
      bindToController: true,
      multiple: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, `options.locals.building` are required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object|Error}               Promise that resolves with the restored documents
     */
    function show(options) {
      // Verify we have building locals
      if (!options || !options.locals || !options.locals.building) {
        $log.error(
          "UploadDocumentDialog: you must pass in building via locals"
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
